<script>
    import { run } from 'svelte/legacy';

    // -- EXPORTS

    /** @type {{value?: boolean, onChange?: any, ariaLabel?: string}} */
    let { value = $bindable(false), onChange = () => {}, ariaLabel = 'Switch' } = $props();

    let checked;
    run(() => {
        checked = value;
    });

    // -- FUNCTIONS

    function handleChangeEvent(
        event
        )
    {
        value = event.target.checked;

        onChange( value );
    }
</script>

<style lang="stylus">
    .switch input
        cursor: pointer
</style>

<div class="switch" role="switch" aria-checked={ checked.toString() } aria-label="{ ariaLabel }">
    <input
        class="input"
        type="checkbox"
        bind:checked
        onchange={handleChangeEvent}
        aria-hidden="true"
    />
    <span class="slider"></span>
</div>
